import styled from 'styled-components/native';

export const Container = styled.View`
  margin: 10px;
  flex: 1;
`;

export const ScreenName = styled.Text`
  font-size: 16px;
  font-family: ${props => props.theme.fonts.MontserratRegular};
`;

export const CardContainer = styled.View`
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
`;

export const HeaderTitleText = styled.Text`
  font-size: 16px;
  color: ${props => props.theme.color.text};
  font-family: ${props => props.theme.fonts.MontserratRegular};
  align-self: center;
`;

export const ActionButton = styled.TouchableOpacity<{ color: string }>`
  margin-right: 10px;
  border: 1px solid ${props => props.color};
  border-radius: 5px;
  width: 30px;
  height: 30px;
  align-items: center;
  padding: 5px;
`;

export const ModalHeader = styled.View`
  flex: 1;
`;

export const ModalHeaderTitle = styled.Text`
  font-size: 18px;
  color: ${props => props.theme.color.text};
  text-align: center;
  font-family: ${props => props.theme.fonts.MontserratRegular};
`;

export const ModalHeaderContainer = styled.View`
  border-bottom-color: ${props => props.theme.color.lightGrey5};
  border-bottom-width: 1px;
  flex-direction: row-reverse;
  padding-bottom: 12px;
  padding-horizontal: 10px;
  margin-top: 10px;
  justify-content: center;
  align-items: center;
`;

export const WebContainer = styled.View`
  padding: 0px 10px;
  flex: 1;
`;

export const ConfirmationDialogContainer = styled.View`
  padding: 5px 15px;
`;

export const ConfirmationText = styled.Text`
  font-size: 15px;
  margin: 6px 0;
  font-family: ${props => props.theme.fonts.MontserratRegular};
  color: ${props => props.theme.color.text};
`;

export const HeaderActionButton = styled.TouchableOpacity`
  margin-right: 10px;
  flex-direction: row;
  align-items: center;
  padding-left: 5px;
  padding-right: 5px;
`;

export const HeaderText = styled.Text`
  font-size: 14px;
  font-family: ${props => props.theme.fonts.MontserratRegular};
  color: ${props => props.theme.color.text};
`;
